import { InjectionToken } from '@angular/core';

export interface ICrypto {
  encrypt(item: string): Promise<string>;
  decrypt(item: string): Promise<string>;
}

export const ICryptoToken = new InjectionToken<ICrypto>('ICrypto');
